// for url non cloudinary
export { Media } from './Media';
// for multiple contentful asset
// can be next on hover
export { DynamicAsset } from './Media';

// for 1 contentful asset
export { default as CtfMedia } from './CtfMedia';
